<template>
    <div class="teacher-filter-container">
        <div class="tab-container">
        <div class="mdc-tab-bar" role="tablist">
            <div class="mdc-tab-scroller">
                <div class="mdc-tab-scroller__scroll-area">
                <div class="mdc-tab-scroller__scroll-content">
                    <div class="px-3">
                        <button class="mdc-tab " :class="{'mdc-tab--active': noCourseSelected }" role="tab" :aria-selected="noCourseSelected" :tabindex="0">
                            <span class="mdc-tab__content">
                                <span class="mdc-tab__text-label">{{ $trans.get('about-teachers.all') }}</span>
                            </span>
                            <span class="mdc-tab-indicator" :class="{'mdc-tab-indicator--active': noCourseSelected }">
                                <span class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
                            </span>
                            <span class="mdc-tab__ripple"></span>
                        </button>
                    </div>

                    <div class="px-3" v-for="(course,index) in courses" :key="index">
                        <button class="mdc-tab " :class="{'mdc-tab--active': isActive(course) }" role="tab" :aria-selected="isActive(course)" :tabindex="index + 1">
                            <span class="mdc-tab__content">
                                <!-- <span class="mdc-tab__icon material-icons" aria-hidden="true">favorite</span> -->
                                <span class="mdc-tab__text-label">{{course.short_name[locale]}}</span>
                            </span>
                            <span class="mdc-tab-indicator" :class="{'mdc-tab-indicator--active': isActive(index) }">
                                <span class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
                            </span>
                            <span class="mdc-tab__ripple"></span>
                        </button>
                    </div>
                </div>
                </div>
            </div>
        </div>
        </div>
        <div class="grid-section">
        <div class="about-grid container">
            <card-about v-for="(worker,index) in activeCourseWorkers" :key="index" :worker="worker" @click.native="opendialog(worker)"></card-about>
        </div>
    </div>
        <teach-dialog :teacher="teacherselected"></teach-dialog>
    </div>
</template>
<script>
import {MDCTabBar} from '@material/tab-bar';
import {MDCDialog} from '@material/dialog';
import CardAbout from './CardAbout';
import TeachDialog from "./TeacherDialog";

export default {
    props:['workers', 'courses'],
    components:{
        CardAbout,TeachDialog
    },
    data() {
        return {
            activeCourse: null,
            dialog: '',
            teacherselected:'',
            locale: window.appLocale,
        }
    },
    computed: {
        activeCourseWorkers() {
            if (! this.activeCourse) {
                return this.workers;
            }
            return this.workers.filter(worker =>
                worker.courses.find(course => course.id === this.activeCourse.id)
            );
        },
        noCourseSelected() {
            return this.activeCourse === null;
        }
    },
    mounted() {
        const tabBar = new MDCTabBar(document.querySelector('.mdc-tab-bar'));
        tabBar.listen("MDCTabBar:activated", ({ detail: { index }}) => {
            if (index === 0) {
                this.activeCourse = null;
            } else {
                this.activeCourse = this.courses[index - 1];
            }
        });
        this.dialog = new MDCDialog(document.querySelector('.mdc-dialog'));
    },
    methods: {
        isActive(course){
            return this.activeCourse == course;
        },
        opendialog(worker){
            this.teacherselected = worker;
            this.dialog.open();
        }
    },
}
</script>
<style lang="scss">
.teacher-filter-container{
   .mdc-tab-bar{
       background-color: #001c33;
        max-width: 1200px;
       margin-left: auto;
       margin-right: auto;
        .mdc-tab {
            height: 80px;
           text-transform: unset;
           .mdc-tab__text-label{
               color: #a5a9ad;
           }
           .mdc-tab-indicator__content--underline{
               border: 2px solid white;
           }
           &.mdc-tab--active {
               .mdc-tab__text-label{
                   color: white;
               }
           }
        }
   }
}
   .tab-container{
       width: 100%;
       background-color: #001c33;
       padding: 0 1rem;
   }
</style>
